import { INHABITANT_STATUS } from '../../../constants/inhabitant'
import { isStaffUser } from '../../../utils/user'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../Building'
import {
  TableBuildingCell,
  TableDateCell,
  TableRoleCell,
  TableStatusCell,
  TableTextCell,
  TableUserCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'
import { REPORT_TABLE_MODAL_CELL_NAME } from '../ReportTableModal.constants'

function getBuildingLabel(option) {
  return option?.title
}

function getBuildingApiParams(id, value) {
  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    exclude_id: value?.id,
    ...(value.isStaffUserAcc ? { responsible_user: id } : null),
    ...(!value.isStaffUserAcc ? { inhabitant: id } : null),
  }
}

export function renderCell({ item, name, ...restProps }) {
  const { [name]: value } = item

  const isStaffUserAcc = isStaffUser(item.owner)

  switch (name) {
    case REPORT_TABLE_MODAL_CELL_NAME.owner:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
    case REPORT_TABLE_MODAL_CELL_NAME.date:
      return <TableDateCell {...restProps} value={value} />
    case REPORT_TABLE_MODAL_CELL_NAME.email:
      return <TableTextCell {...restProps} value={value} />
    case REPORT_TABLE_MODAL_CELL_NAME.views:
      return <TableTextCell {...restProps} value={value} />
    case REPORT_TABLE_MODAL_CELL_NAME.building:
      return (
        <TableBuildingCell
          {...restProps}
          getApiParams={getBuildingApiParams}
          getLabel={getBuildingLabel}
          id={item.id}
          value={{ ...value, isStaffUserAcc }}
        />
      )
    case REPORT_TABLE_MODAL_CELL_NAME.status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={INHABITANT_STATUS}
          value={value}
        />
      )
    case REPORT_TABLE_MODAL_CELL_NAME.role:
      return <TableRoleCell {...restProps} value={value} />
    default:
      return null
  }
}
